import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

export function SignOut() {
  const navigate = useNavigate()

  useEffect(() => {
    // Show success message and redirect to sign in
    toast.success('Successfully signed out!')
    navigate('/auth/signin', { replace: true })
  }, [navigate])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p className="text-lg font-medium">Signing out...</p>
      </div>
    </div>
  )
}
